export default function About() {
  return (
    <main className="container">
      <div className="card">
        <h2 style={{ marginTop: 0 }}>Sobre Nosotros</h2>

        <p className="p">
          🎙️ <strong>El Show de las Banqueras</strong> es un podcast dinámico,
          auténtico y entretenido, creado con el objetivo de informar y orientar
          al público sobre todo lo relacionado con el mundo de los juegos de azar
          en la República Dominicana. Nuestro enfoque es claro y directo,
          utilizando un lenguaje cotidiano y real, al estilo único de las
          banqueras, quienes viven y conocen este sector desde dentro.
        </p>

        <p className="p">
          En cada episodio abordamos temas de interés general, noticias del
          sector, experiencias reales, opiniones, aclaraciones y situaciones
          cotidianas que forman parte del día a día en las bancas y en la vida de
          los jugadores. Buscamos no solo informar, sino también educar,
          entretener y crear conciencia, siempre desde una perspectiva cercana y
          honesta.
        </p>

        <p className="p">
          Cada episodio tiene una duración aproximada de <strong>30 minutos</strong>,
          con contenido original, fresco y pensado para conectar con nuestra
          audiencia. 📅 <strong>Estrenamos nuevos episodios todos los lunes</strong>,
          reafirmando nuestro compromiso de ofrecer un espacio constante de
          información, entretenimiento y comunidad.
        </p>
      </div>
    </main>
  );
}
